import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BranchDesignationContainerModel} from '../../../../../../models';
import {BaseApiTemplateService, Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class BranchDesignationService extends BaseApiTemplateService<BranchDesignationContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/branch-designation/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/branch-designation/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/branch-designation/backoffice-ep';
    this.httpClient = http;
  }

}
